<template>
    <button class="btn" :class="myClass" @click="clicked" type="button">
        <i v-if="!loading" class="fa-fw" :class="myIcon"></i>
        <i v-if="loading" class="fa fa-fw fa-spinner fa-spin"></i>

        <slot></slot>
    </button>
</template>

<script>
    export default {
        props: [
            'click', // function to be called when you click the button. Returns a promise.
            'icon',

            'cssClass'
        ],
        data() {
            return {
                loading: false
            }
        },
        computed: {
            myClass() {
                return this.cssClass || 'btn-sm btn-primary';
            },
            myIcon() {
                return this.icon || 'fas fa-check';
            }
        },
        methods: {
            clicked() {
                if (this.loading) {
                    return;
                }
                if (!this.click || typeof this.click !== "function") {
                    return;
                }

                this.loading = true;

                let clickResult = this.click();
                if (clickResult && clickResult.finally) {
                    clickResult.finally(() => {
                        this.loading = false;
                    });
                }
                else {
                    this.loading = false;
                }
            }
        }
    }
</script>

<style>
</style>